import { Sprint } from 'features/sprint';
import { useParticipantsSprintsQuery } from 'features/sprint/hooks';

const DEFAULT_RECENT_SPRINTS = [] as Sprint[];

export const useRecentSprints = (numberOfRecentSprints = 2) => {
  const { data: sprints } = useParticipantsSprintsQuery();

  return sprints?.slice(0, numberOfRecentSprints) || DEFAULT_RECENT_SPRINTS;
};
